import { EntityListTypeName } from '@ydistri/api-sdk';
import { ProjectAdministrationSubpage } from '../../../projectAdministrationLib';
import { SkuEntityListSpecification } from './SkuEntityListSpecification';

export class TargetEntityListSpecification extends SkuEntityListSpecification {
  constructor() {
    super(
      ProjectAdministrationSubpage.TARGETLISTS,
      'Target list administration',
      'Target list',
      'Target lists',
      'TGT',
      [EntityListTypeName.Source, EntityListTypeName.Forced],
    );
  }
}
